import { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Full-viewport modal backdrop + centering shell. Portals to document.body so
 * fixed positioning is not clipped or offset by Layout/sidebar ancestors.
 */
export default function ModalOverlay({
  open,
  onClose,
  children,
  zIndex = 50,
  className = '',
  closeOnBackdrop = true,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className={`fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-black/50 p-4 ${className}`.trim()}
      style={{
        zIndex,
        margin: 0,
        minHeight: '100dvh',
        width: '100vw',
      }}
      role="presentation"
      onClick={closeOnBackdrop ? onClose : undefined}
    >
      {children}
    </div>,
    document.body
  );
}
